// Canonical list of i18n collections (namespaces).
//
// This is the single source of truth for which translation collections the app
// loads. It MUST stay in sync with:
//   - the JSON files in src/i18n/en-US/
//   - the COLLECTIONS env var in .github/actions/pull-translations/action.yml
//
// The `npm run check:i18n` guard (scripts/check-i18n-collections.mjs) enforces
// this and fails CI / pre-push if any of the three drift apart. When adding a
// new collection, add its name here.
export const collections = [
  'common',
  'navigation',
  'divisions',
  'companies',
  'users',
  'apps',
  'settings',
  'profile',
  'notifications',
  'products',
  'organizations',
  'support',
  'topconId',
  'errors',
];
